import { GET_ALL_VOLTAGE_RANGES_URL } from 'constants/apiEndpoints';
import httpClient from 'services/apiClient';

const VoltageRangeService = {
  getAllVoltageRanges: async () => {
    try {
      return await httpClient.get(GET_ALL_VOLTAGE_RANGES_URL);
    } catch (error: any) {
      return error.response;
    }
  }
};

export default VoltageRangeService;
